import { AppError } from "./appError.js";
export class InvalidTokenFormat extends AppError {
    status = 400;
    message = "Invalid token format.";
    code = "auth/invalid-token-format";
}
export class InvalidToken extends AppError {
    status = 401;
    message = "Supplied token invalid.";
    code = "auth/invalid-token";
}
export class IpAddressNotWhitelisted extends AppError {
    status = 403;
    message = "IP address not whitelisted.";
    code = "auth/ip-address-not-whitelisted";
    constructor(ip) {
        super();
        this.message = `IP address not whitelisted: "${ip}"`;
    }
}
export class NoValidCertificate extends AppError {
    status = 403;
    message = "No valid certificate.";
    code = "auth/no-valid-certificate";
}
export class AuthenticationRequired extends AppError {
    status = 401;
    message = "Authentication required for this operation.";
    code = "auth/authentication-required";
}
export class InsufficientPermissions extends AppError {
    status = 403;
    message = "Insufficient permissions for this operation.";
    code = "auth/insufficient-permissions";
    constructor(operation) {
        super();
        if (operation) {
            this.message = `Insufficient permissions for operation: ${operation}`;
        }
    }
}
export class ResourceNotFound extends AppError {
    status = 404;
    message = "Requested resource not found.";
    code = "auth/resource-not-found";
    constructor(resource, id) {
        super();
        this.message = `${resource} not found: ${id}`;
    }
}
export class AgencyMismatch extends AppError {
    status = 403;
    message = "Resource does not belong to the user's agency.";
    code = "auth/agency-mismatch";
}
